import { Component, forwardRef, inject, input, OnInit } from '@angular/core'
import { AbstractControl, ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms'
import { UtilsService } from '../../services/utils.service'

@Component({
    selector: 'app-module-switcher',
    templateUrl: './module-switcher.component.html',
    styleUrls: ['./module-switcher.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ModuleSwitcherComponent),
            multi: true,
        },
    ],
})
export class ModuleSwitcherComponent implements OnInit, ControlValueAccessor {
    public readonly utilsService = inject(UtilsService)
    public readonly label = input.required<string>()

    public readonly control = input.required<AbstractControl | FormControl>()
    public controlName: string | null = null

    value: any

    onChange: any = (value: any) => {}
    onTouched: any = () => {}

    constructor() {}

    ngOnInit(): void {
        this.controlName = this.utilsService.getControlName(this.control())
    }

    writeValue(value: any): void {
        this.value = value
    }

    registerOnChange(fn: any): void {
        this.onChange = fn
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn
    }

    setDisabledState?(isDisabled: boolean): void {}
}
